
import React, { useCallback } from 'react'
import { GoogleMap, LoadScript, MarkerF, useJsApiLoader } from '@react-google-maps/api'
import Typography from '@mui/material/Typography'
import { Avatar, Grid, Stack } from '@mui/material'


type Props = {
    el?: any
}

export function SyncmeItem(props: Props) {
    const el = props?.el || {}
    return (
        <Grid item xs={6}>
            {el?.PhotoPath && (
                <Grid sx={{ display: 'flex' }}>
                    <Grid item xs={4}>
                        <Typography variant="text" fontSize={14}>
                            {'Photo:'}
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Avatar
                            src={el?.PhotoPath}
                            sx={{
                                height: 75,
                                width: 75,
                            }} />
                    </Grid>
                </Grid>
            )}
        </Grid>
    )

}

export default SyncmeItem